import { render } from "./FooteR.vue?vue&type=template&id=06f1158b&scoped=true"
import script from "./FooteR.vue?vue&type=script&lang=js"
export * from "./FooteR.vue?vue&type=script&lang=js"

import "./FooteR.vue?vue&type=style&index=0&id=06f1158b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f1158b"]])

export default __exports__